import React, { useState, MouseEvent } from 'react';
import { IconsName } from 'ui';
import { useClickAway } from 'react-use';
import {
  SelectContainer,
  DropdownContainer,
  Arrow,
  SelectButton,
  DropdownElement,
  DropdownInnerContainer,
} from './Select.styled';

type IdType = {
  id: string | number;
};

export interface SelectItem<T extends IdType> {
  id: T;
  name: string;
}

export interface SelectProps<T extends IdType> {
  className?: string;
  chosen: T | undefined;
  options: SelectItem<T>[];
  onChoose: (id: T) => void;
  placeholder: string;
  align?: 'left' | 'right';
  icon?: (typeof IconsName)[number];
  iconAlign?: 'left' | 'right';
}

export const LegacySelect = <T extends IdType>({
  className,
  options,
  placeholder,
  chosen,
  align = 'left',
  onChoose,
  icon = 'arrowDown',
  iconAlign = 'right',
}: SelectProps<T>) => {
  const [open, setOpen] = useState(false);
  const chosenItem = options.find((el) => chosen === el.id);
  const ref = React.useRef<HTMLDivElement>(null);

  const onDocumentClick = (e?: MouseEvent) => {
    e?.preventDefault();
    e?.stopPropagation();
    setOpen(false);
  };

  useClickAway(ref, () => onDocumentClick());

  const onOpenButtonClick = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    if (!open) setOpen(true);
  };

  const onDropdownClick = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const choose = (id: T) => {
    onChoose(id);
    setOpen(false);
  };

  return (
    <SelectContainer ref={ref} className={className}>
      <SelectButton onClick={open ? onDocumentClick : onOpenButtonClick} $open={open}>
        {iconAlign === 'left' && <Arrow name={icon} $isOpen={open} />}
        {chosenItem ? chosenItem.name : placeholder}
        {iconAlign === 'right' && <Arrow name={icon} $isOpen={open} />}
      </SelectButton>

      <DropdownContainer onClick={onDropdownClick} align={align} $isOpen={open}>
        <DropdownInnerContainer>
          {options.map((el) => (
            <DropdownElement key={`${el.id}`} onClick={() => choose(el.id)}>
              {el.name}
            </DropdownElement>
          ))}
        </DropdownInnerContainer>
      </DropdownContainer>
    </SelectContainer>
  );
};
